import type { FaireProductEntity } from "../../entity_types/product";

export const p_3hbm34s26f: FaireProductEntity = {
  token: "p_3hbm34s26f",
  type: "product",
  name: "🌿 Bubbly Bath Soak – Relax & Restore",
  brandToken: "b_ad8bjvlw5g",
  brandName: "Untamed Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/b2d28c6e0e7887288fd0094bcf71a38465db07d798673b0daead6853594de722.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/399146c7be8f11646cf53c91fae7f9b64ae2dae238e1a8eb4776adede9dbadeb.jpeg",
  ],
  priceDollars: 12.46,
  description:
    "\nSoothe your soul and your sore muscles.\n\nGet your mineral fix topically with our super blend of Dead Sea salt, Epsom salt, and pure sodium chloride helps melt away tension while eucalyptus essential oil turns your tub into a steamy, spa-like sanctuary. It's like a mini nature retreat. \n\nAnd yesssss, it bubbles! Not a full-blown bubble bath but just enough suds and foam to feel fun and light. \n\n🛁 Perfect for: Post-workout aches, stressful days and reclaiming five minutes of peace and tranquility yourself.\n\n🌱 Key ingredient benefits:\n\n * \nDead Sea Salt – Rich in minerals to detox and soothe tired muscles\n\n * \nEpsom Salt – A magnesium boost to help relax the body and mind\n\n * \nSodium Chloride – Draws out impurities and softens skin\n\n * \nEucalyptus Essential Oil – Clears the airways and calms the nerves\n\n🧪 No weird stuff: Just clean, plant based ingredients that love your body back.",
  tags: [],
  msrpDollars: 24.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:42.230Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
